import { Routes } from '@angular/router';
import { ProvidersDashboardComponent } from './common/providers-dashboard/providers-dashboard.component';
import { AnonymousGuardService } from './services/auth/AnonymousGuard.service';
import { AuthGuardService } from './services/auth/auth-guard.service';

export const carServicesProvidersRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: ProvidersDashboardComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'requests',
        pathMatch: 'full'
      },
      {
        path: 'requests',
        loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule)
      }
    ]
  },
  {
    path: 'login',
    canActivate: [AnonymousGuardService],
    loadChildren: () => import('./auth/auth.module').then(m => m.CsProviderAuthModule)
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];